import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { QUERY_KEYS } from "@/query-keys";
import type { ApiQueryParams } from "@/types/api-types";

export const usePlatformGroupQueries = () => {
  const api = useApi();

  return {
    list: (platformGroupsQueryParams: ApiQueryParams<"getSystemGroupsV1">) =>
      queryOptions({
        queryKey: QUERY_KEYS.PLATFORM_GROUPS_LIST(platformGroupsQueryParams),
        queryFn: () => api.getSystemGroupsV1(platformGroupsQueryParams),
        select: commonAPIDataSelector,
        placeholderData: (previousData) => previousData,
      }),

    details: (groupId: string) =>
      queryOptions({
        queryKey: QUERY_KEYS.PLATFORM_GROUP_DETAILS(groupId),
        queryFn: () => api.getSystemGroupsDetailsV1(groupId),
        select: commonAPIDataSelector,
      }),
  };
};
